import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import messages from './messages';
import style from './style.module.less';
import { SimpleModal } from '../../../components/simple-modal/simple-modal';

/**
 * @param {object} params
 * @param {() => void} params.onClose
 * @param {(iorId: string) => void} params.onDelete
 * @param {string} params.iorId
 * @returns {JSX.Element}
 */
export const DeleteIORModal = ({ onClose, onDelete, iorId }) => {
  const onDeleteClicked = useCallback(() => {
    onDelete(iorId);
  }, [onDelete, iorId]);

  return (
    <SimpleModal
      actionButtonTheme={THEME_CONSTANTS.danger}
      actionMessage={messages.delete}
      cancelMessage={messages.cancel}
      headerMessage={messages.deleteIORModalHeader}
      onAction={onDeleteClicked}
      onCancel={onClose}
      onClose={onClose}
    >
      <div className={style.warning}>
        <FormattedMessage {...messages.confirmIORDeleteMessage} />
      </div>
    </SimpleModal>
  );
};
